import { render } from "./CardBoxComponentFooter.vue?vue&type=template&id=0f78a149"
const script = {}

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__